import { useState } from "react";

interface ArticleCTAProps {
  ctaImageUrl: string;
}

export default function ArticleCTA({ ctaImageUrl }: ArticleCTAProps) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<
    "idle" | "loading" | "success" | "error"
  >("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const hpField = formData.get("website_alt") as string;
    if (hpField && hpField.trim() !== "") {
      setStatus("success");
      setEmail("");
      return;
    }

    if (!email.trim()) {
      setErrorMsg("请输入邮箱地址");
      setStatus("error");
      return;
    }

    setStatus("loading");
    setErrorMsg("");

    try {
      const payload = new URLSearchParams();
      payload.append("email", email.trim());
      formData.forEach((value, key) => {
        if (key !== "website_alt" && key !== "email") {
          payload.append(key, value.toString());
        }
      });

      const response = await fetch(
        "https://readdy.ai/api/form/d96cmv5tfb6ioa7s1mr0",
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: payload.toString(),
        }
      );

      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore
      }

      if (response.ok && (parsed as { code?: string })?.code === "OK") {
        setStatus("success");
        setEmail("");
      } else {
        const serverMsg =
          (parsed as { meta?: { message?: string } })?.meta?.message ||
          (parsed as { message?: string })?.message ||
          "订阅失败，请稍后重试";
        setErrorMsg(serverMsg);
        setStatus("error");
      }
    } catch {
      setErrorMsg("网络错误，请稍后重试");
      setStatus("error");
    }
  };

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto text-center">
        <div className="rounded-2xl overflow-hidden mb-10 md:mb-14">
          <img
            src={ctaImageUrl}
            alt="订阅每日黑料推送"
            title="每日黑料推送"
            className="w-full aspect-[2/1] object-cover"
          />
        </div>

        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-3 leading-snug">
          每天都有新爆料，第一时间掌握网红塌房信息！
        </h2>
        <p className="text-base text-foreground-400 italic font-light mb-10">
          关注我们，不错过任何一个大瓜
        </p>

        <form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
          data-readdy-form=""
        >
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="hp-field"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入邮箱，每日黑料准时送达"
            required
            className="w-full sm:flex-1 px-5 py-3 text-sm bg-background-100 border border-background-400/50 rounded-full text-foreground-200 placeholder:text-foreground-600 outline-none focus:border-primary-500/50 transition-colors duration-200"
          />
          <button
            type="submit"
            disabled={status === "loading"}
            className="whitespace-nowrap w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-foreground-50 font-medium rounded-full transition-all duration-200 disabled:opacity-60"
          >
            {status === "loading" ? "提交中..." : "📬 订阅每日黑料推送"}
          </button>
        </form>

        {status === "success" && (
          <p className="mt-4 text-sm text-primary-400">
            订阅成功！每日黑料将准时送达你的邮箱。
          </p>
        )}
        {status === "error" && (
          <p className="mt-4 text-sm text-red-400">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}